import React, { useCallback } from "react";
import { Radio } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import * as gtag from "../../../../../lib/gtag";

const StyledRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 20px;
`;

const StyledRadio = styled(Radio)`
  /* width: 100%; */
`;

const StyledRadioGroup = styled(Radio.Group)`
  padding: 0 42px;
  width: 100%;
`;

const Label = styled.span`
  margin: 0 20px;
  font-weight: 900;
  white-space: nowrap;
`;

const CandidatesType = styled.span`
  color: ${({ theme }) => theme["@gray-80"]};
  font-size: 12px;
  font-weight: 500;
`;

function SortBy({ loading, onChange, value }) {
  const { t } = useTranslation();
  const sortOptions = ["score", "date", "fullname"];
  const handleChange = useCallback(
    event => {
      gtag.event({
        category: "VacancyCandidates",
        action: `sortBy${event.target.value}`
      });
      onChange(event.target.value);
    },
    [onChange]
  );
  return (
    <StyledRadioGroup disabled={loading} onChange={handleChange} value={value}>
      <StyledRow>
        <Label>{t("components:SortBy.label")}</Label>
        {sortOptions.map(type => (
          <StyledRadio key={type} data-test={`sort-by-${type}`} value={type}>
            <CandidatesType>{t(`components:SortBy.${type}`)}</CandidatesType>
          </StyledRadio>
        ))}
      </StyledRow>
    </StyledRadioGroup>
  );
}

export default SortBy;
